/**
 * Dibuja la imagen en un canvas aplicando `filter` (CSS filter string) y devuelve JPEG.
 */
function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

export async function applyCanvasFilterToBlob(
  imageSrc: string,
  filterCss: string
): Promise<Blob> {
  const img = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("No canvas context");
  }
  const f = filterCss.trim();
  ctx.filter = f && f !== "none" ? f : "none";
  ctx.drawImage(img, 0, 0);
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error("Empty canvas"));
        else resolve(blob);
      },
      "image/jpeg",
      0.92
    );
  });
}
